export default __webpack_public_path__ + "static/media/key.5f0ac0c7.svg";